











import { Component, Prop, Vue } from 'vue-property-decorator';
import { createDataField } from '@/utils/fullStatementView';
import { StatementType } from '@/types/services';

const PersonBusinessmanTitle: any = {
  [StatementType.NOTICE_RECOVERY]: createDataField({
    fieldName: 'isBusinessmanApplicant',
    fieldGroup: 'person',
  }),
  [StatementType.RUZDI]: createDataField({
    fieldName: 'isBusinessman',
    fieldGroup: 'person',
  }),
  [StatementType.SECURING_EVIDENCE]: createDataField({
    fieldName: 'isBusinessman',
    fieldGroup: 'person',
  }),
};

@Component({
  inheritAttrs: false,
})
export default class TitleField extends Vue {
  @Prop() private fieldName!: string;
  @Prop() private fieldGroup!: string;
  @Prop() private statementType?: string;
  @Prop({ type: Boolean, default: false }) private isApplicant?: boolean;

  createDataField = createDataField;
  PersonBusinessmanTitle = PersonBusinessmanTitle;

  get labelApplicant() {
    return (
      this.statementType &&
      this.PersonBusinessmanTitle[this.statementType].fieldLabel
    );
  }
}
